import { render } from "./UpitnikKreiranje.vue?vue&type=template&id=04f5976c&scoped=true"
import script from "./UpitnikKreiranje.vue?vue&type=script&lang=js"
export * from "./UpitnikKreiranje.vue?vue&type=script&lang=js"

import "./UpitnikKreiranje.vue?vue&type=style&index=0&id=04f5976c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04f5976c"

export default script